import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import InfoCard from "layouts/profile/components/InfoTab/InfoCard";
import InfoSummary from "layouts/profile/components/InfoTab/InfoSummary";

function InfoTab() {
  return (
    <Grid container spacing={1}>
        <Grid item xs={12} md={12} xl={4}>
            <InfoCard />
        </Grid>
        <Grid item xs={12} md={12} xl={8} sx={{ display: "flex" }}>
            <Divider orientation="vertical" sx={{ ml: -2, mr: 1 }} />
            <InfoSummary />
        </Grid>
    </Grid>
  );
}

export default InfoTab;
